import { ProjectActions } from "../../reducers/project/actionsNames";
import { Category } from "../../reducers/project";

export default (category?: Category[]) => ({
  type: ProjectActions.SetActive,
  active: category,
});
